export default {
  title: "Апарати",
  subtitle: "Управление на лабораторни апарати и тяхната конфигурация",
  add: "Добавяне на апарат",
  edit: "Редактиране",
  delete: "Изтриване",
  refresh: "Обновяване",
  navigate: "Отваряне на детайли на апарата",
  add_title: "Добавяне на апарат",
  add_subtitle: "Регистриране на нов апарат на тази локация",
  subtitle_name: "Апарат",
  subtitle_id: "ID на апарат",
  subtitle_lis_id: "LIS ID",
  subtitle_location: "Локация",
  subtitle_name_tooltip: "Наименование на апарата",
  subtitle_id_tooltip: "Системен идентификатор",
  subtitle_lis_id_tooltip: "LIS ID",
  subtitle_location_tooltip: "Локация на апарата",
  subtitle_serial: "Сериен номер",
  subtitle_serial_tooltip: "Сериен номер на апарата",
  subtitle_decimal_separator: "Десетичен знак",
  subtitle_decimal_separator_tooltip: "Знакът, използван за десетичен разделител в числовите резултати от апарата.",
  subtitle_note: "Бележка",
  subtitle_note_tooltip: "Бележка за апарата",
  edit_title: "Редактиране на апарат",
  delete_title: "Изтриване на апарат",
  delete_message: "Този апарат ще бъде трайно премахнат. Всички свързани канали също ще бъдат изтрити.",
  delete_dependency_checking: "Проверява се дали апаратът има свързана конфигурация...",
  delete_dependency_check_failed:
    "Свързаната конфигурация не можа да бъде проверена. Моля, опитайте отново преди изтриване на апарата.",
  delete_has_channels:
    "Този апарат не може да бъде изтрит, защото все още има конфигурирани канали. Моля, премахнете ги първо от страницата Канали.",
  delete_has_tests:
    "Този апарат не може да бъде изтрит, защото все още има конфигурирани тестове. Моля, премахнете ги първо от раздела Тестове.",
  delete_has_panels:
    "Този апарат не може да бъде изтрит, защото все още има конфигурирани панели. Моля, премахнете ги първо от раздела Панели.",
  delete_has_sample_types:
    "Този апарат не може да бъде изтрит, защото все още има конфигурирани типове проби. Моля, премахнете ги първо от раздела Типове проби.",
  delete_has_flags:
    "Този апарат не може да бъде изтрит, защото все още има конфигурирани флагове. Моля, премахнете ги първо от раздела Флагове.",
  delete_has_rights:
    "Този апарат не може да бъде изтрит, защото все още има конфигурирани права за достъп. Моля, премахнете ги първо от раздела Права.",

  fields: {
    name: "Наименование",
    name_hint: "Показвано наименование на апарат в системата.",
    name_placeholder: "напр. Cobas e801, Sysmex XN-1000",
    location: "Локация",
    location_hint: "Физическото място, където е инсталиран апарат.",
    decimal_separator: "Десетичен знак",
    decimal_separator_hint: "Знакът, използван за десетичен разделител в числовите резултати от апарата.",
    decimal_separator_placeholder: ". или ,",
    mapping_key: "LIS ID",
    mapping_key_hint: "Външен идентификатор за съответствие на апарат в LIS/HIS.",
    mapping_key_placeholder: "напр. COBAS01",
    serial: "Сериен номер",
    serial_hint: "Сериен номер на апарата",
    serial_placeholder: "напр. SN-12345",
    note: "Бележка",
    note_hint: "По избор — видимо в заглавието и подсказките.",
    note_placeholder: "напр. Основен хематологичен анализатор, маса 2",
  },

  validation: {
    name_required: "Наименованието е задължително",
    name_too_long: "Наименованието трябва да е най-много 100 символа",
    name_taken: "Вече съществува апарат с това име",
    location_required: "Локацията е задължителна",
    decimal_separator_required: "Десетичният знак е задължителен",
    mapping_key_too_long: "LIS ID трябва да е най-много 100 символа",
    mapping_key_taken: "Вече съществува апарат с този LIS ID",
    serial_too_long: "Серийният номер трябва да е най-много 100 символа",
    note_too_long: "Бележката трябва да е най-много 500 символа",
  },

  snackbar_added: 'Апарат "{name}" е добавен',
  snackbar_updated: 'Апарат "{name}" е актуализиран',
  snackbar_deleted: 'Апарат "{name}" е изтрит',
  loadFailed: "Зареждането на апаратите не успя",

  onboarding: {
    configure_channel: "Настрой канал",
  },

  list: {
    search_placeholder: "Търсене на апарати",
    tab_all: "Всички апарати",
    filter_location_all: "Всички локации",
    filter_location_tooltip: "Филтриране по локация",
    filter_location_active_tooltip: "Филтрирано по: {name}",
    status_total: "{count} апарат | {count} апарата",
    navigate: "Отваряне на детайли на апарата",
    collapse_group: "Свиване на локацията",
    expand_group: "Разгъване на локацията",
    channels_total: "Общо канали",
    channels_connected: "Свързани канали",
    channels_running: "Работещи канали",
    channels_enabled: "Активирани канали",
    mapping_key_tooltip: "Външен ключ за съответствие за идентификация на апарата в свързани LIS/HIS системи",
    status_healthy: "Каналът е свързан",
    status_degraded: "Каналът не е свързан",
    status_offline: "Каналът не е активен",
    status_no_channels: "Няма конфигуриран канал",
    channel_label_total: "Общо",
    channel_label_connected: "Свързани",
    channel_label_running: "Активни",
    channel_label_enabled: "Активирани",
    metadata: {
      locations: {
        label: "Локации",
        tooltip: "Локации с конфигурирани апарати",
      },
      instruments: {
        label: "Апарати",
        tooltip: "Общо конфигурирани апарати",
      },
      channels: {
        label: "Канали",
        tooltip: "Общо комуникационни канали на всички апарати",
      },
      connected: {
        label: "Свързани",
        tooltip: "Канали с активна връзка към апарат",
      },
      running: {
        label: "Активни",
        tooltip: "Канали, активирани от Iris Core",
      },
    },
    toolbar: {
      refresh: "Обновяване",
    },
    columns: {
      name: "Апарат",
      mapping_key: "LIS ID",
      decimal_separator: "Десетичен знак",
      decimal_separator_tooltip: "Знакът, използван като десетичен разделител в числовите резултати на апарат.",
      decimal_dot: "точка",
      decimal_comma: "запетая",
      channels: "Канали",
      location: "Локация",
      driver: "Драйвер / Протокол",
      driver_hint: "Комуникационен протокол, използван от каналите на апарат.",
      test_count: "Бр. Тестове",
    },
    no_channels: "Няма канали",
    empty: {
      title: "Няма налични апарати",
      description: "Все още няма конфигурирани апарати.",
    },
  },

  page_header: {
    description: "Забележка за конкретен апарат.",
  },

  detail: {
    save: "Запази промените",
    reset: "Нулиране",
    toolbar: {
      refresh_tests: "Обновяване",
      refresh_panels: "Обновяване",
      refresh_sample_types: "Обновяване",
      refresh_rights: "Обновяване",
      refresh_flags: "Обновяване",
      refresh_mappings: "Обновяване",
      refresh_processors: "Обновяване",
    },
  },

  tabs: {
    details: "Детайли",
    tests: "Тестове",
    panels: "Панели",
    sample_types: "Видове проби",
    rights: "Права",
    flags: "Флагове",
  },

  tests_tabs: {
    tests_list: "Тестове",
    mappings: "LIS съответствия",
    processors: "Процесори",
  },

  test_detail: {
    description: "Забележка за конкретен тест.",
    tabs: {
      basic_data: "Основни данни",
      mapping: "LIS съответствия",
      processors: "Процесори",
    },
    navigate: "Отваряне на детайли на теста",
    save_success: "Тестът е запазен успешно",
    save_error: "Грешка при запазване на теста",
    toggle_activated: "Тестът е активиран успешно",
    toggle_deactivated: "Тестът е деактивиран успешно",
    toggle_error: "Грешка при промяна на статуса на теста",
    mapping_added: "Съответствието '{key}' е добавено",
    mapping_updated: "Съответствието '{key}' е обновено",
    mapping_deleted: "Съответствието '{key}' е премахнато",
    mapping_add_error: "Грешка при добавяне на съответствие. Моля, опитайте отново.",
    mapping_update_error: "Грешка при обновяване на съответствие. Моля, опитайте отново.",
    mapping_delete_error: "Грешка при премахване на съответствие. Моля, опитайте отново.",
    processor_added: "Процесор #{rank} е добавен",
    processor_updated: "Процесор #{rank} е обновен",
    processor_deleted: "Процесор #{rank} е премахнат",
    processor_add_error: "Грешка при добавяне на процесор. Моля, опитайте отново.",
    processor_update_error: "Грешка при обновяване на процесор. Моля, опитайте отново.",
    processor_delete_error: "Грешка при премахване на процесор. Моля, опитайте отново.",
    delete_success: "Тестът е изтрит успешно",
    delete_error: "Неуспешно изтриване на теста. Моля, опитайте отново.",

    delete: "Изтриване",
    master_card: {
      cannot_be_ordered: "Не може да се нарежда",
      cannot_be_ordered_hint: "Тестът не може да получава нареждания от LIS",
      cannot_be_result: "Без резултати",
      cannot_be_result_hint: "Тестът не може да произвежда стойности на резултати",
      created_on: "Създаден",
    },
    unsaved_dialog_title: "Незапазени промени",
    unsaved_dialog_subtitle: "Имате незапазени промени.",
    unsaved_dialog_body: "Искате ли да запазите промените преди да напуснете, или да ги отхвърлите?",
    unsaved_save_and_leave: "Запазване и продължаване",
    unsaved_discard: "Отхвърляне",
    unsaved_stay: "Оставане",
    subtitle_code_tooltip: "Код на теста за LIS нареждания",
    subtitle_name_tooltip: "Показвано наименование на теста",
    subtitle_id_tooltip: "Системен идентификатор",
  },

  panel_detail: {
    tabs: {
      basic_data: "Основни данни",
      mapping: "LIS съответствия",
      tests: "Тестове",
    },
    activate: "Активиране",
    deactivate: "Деактивиране",
    save: "Запазване",
    reset: "Възстановяване",
    delete: "Изтриване",
    save_success: "Панелът е запазен успешно",
    save_error: "Неуспешно запазване на панела",
    toggle_activated: "Панелът е активиран успешно",
    toggle_deactivated: "Панелът е деактивиран успешно",
    toggle_error: "Неуспешна промяна на статуса на панела",
    master_card: {
      created_on: "Създаден",
    },
    subtitle_panel: "Панел",
    subtitle_id: "ID на панел",
    subtitle_code_tooltip: "Код на панела за LIS нареждания",
    subtitle_name_tooltip: "Показвано наименование на панела",
    subtitle_id_tooltip: "Системен идентификатор",
    delete_dialog: {
      title: "Изтриване на панел",
      subtitle: "Изтриване на {name}",
      confirm: "Изтриване",
      warning: "Този панел ще бъде окончателно премахнат от апарата.",
      has_related_items: "Панелът не може да бъде изтрит, докато има LIS съответствия или тестове.",
    },
  },

  mappings_table: {
    columns: {
      test_name: "Тест",
      mapping_key: "Код",
      lis_name: "LIS наименование",
    },
    empty: {
      title: "Няма съответствия",
      description: "Няма конфигурирани съответствия за тестовете на този апарат.",
    },
  },

  processors_table: {
    columns: {
      test_name: "Тест",
      rank: "Ред",
      active: "Активен",
      type: "Тип",
    },
    empty: {
      title: "Няма процесори",
      description: "Няма конфигурирани процесори за тестовете на този апарат.",
    },
  },

  coming_soon: {
    panels: {
      title: "Разделът е в разработка",
      description: "Този раздел е в процес на изграждане и ще бъде достъпен скоро.",
    },
  },

  panels: {
    title: "Панели",
    subtitle: "Тестови панели, конфигурирани за този апарат",
    empty_title: "Няма конфигурирани панели",
    empty_description: "Няма конфигурирани панели за този апарат.",
    columns: {
      panel: "Панел",
      panel_name: "Панел",
      code: "Код",
      name: "Наименование",
      behaviour: "Режим на поръчване",
      behaviour_column_hint: "Начинът на поръчване на панела — определя кои тестове се включват и в какъв режим.",
      tests: "Тестове",
      tests_count: "Бр. Тестове",
      tests_tooltip: "Брой тестове в панела.",
      mappings: "LIS съответствия",
      mappings_count: "Бр. LIS съответствия",
      mappings_tooltip: "Брой LIS идентификатори, конфигурирани за този панел.",
      created: "Създаден",
      date_time: "Дата / Час",
      date_time_tooltip: "Датата и часът на създаване на панела.",
      actions: "Действия",
      open: "Отваряне",
    },
    add_title: "Добавяне на панел",
    add_subtitle: "Дефинирайте нов тестови панел за апарата.",
    subtitle_name_tooltip: "Показвано наименование на панела",
    subtitle_id_tooltip: "Системен идентификатор на панела",
    edit_title: "Редактиране на панел",
    action_add: "Добавяне на панел",
    action_edit: "Редактиране на панел",
    action_delete: "Изтриване на панел",
    navigate: "Отваряне на детайли за панела",
    fields: {
      code: "Код",
      code_hint: "Кратък идентификатор на панел.",
      code_placeholder: "напр. LIPID",
      name: "Име",
      name_hint: "Пълно наименование, показвано в отчетите и LIS.",
      name_placeholder: "напр. Липиден панел",
      behaviour: "Режим на поръчване",
      status: "Състояние",
      activate: "Активирай",
      deactivate: "Деактивирай",
    },
    validation: {
      code_required: "Кодът е задължителен",
      code_too_long: "Кодът трябва да е до 50 символа",
      code_duplicate: "Вече има панел с този код за този апарат",
      name_required: "Името е задължително",
      name_too_long: "Името трябва да е до 255 символа",
      name_duplicate: "Вече има панел с това име за този апарат",
    },
    delete_title: "Изтриване на панел",
    delete_message: "Този панел ще бъде премахнат от конфигурацията на апарата.",
    delete_blocked: "Първо премахнете всички LIS съответствия и тестове ({mappings} съответствия, {tests} теста).",
    status_enabled: "Активен",
    disabled: "Деактивиран",
    status_disabled: "Деактивиран",
    behaviour: {
      none: "Игнориран",
      single_unit: "Единичен елемент",
      fixed: "Фиксиран списък от тестове",
      joined: "Обединен списък от тестове",
    },
    behaviour_hints: {
      none: "Игнорира се при поръчване. Подходящо за чернови или информационни панели.",
      single_unit: "Поръчва панела като един елемент, без разширяване към отделни тестове.",
      fixed: "Разширява се към конфигурираните в Iris тестове, маркирани за фиксирано поръчване.",
      joined: "Комбинира тестовете от адаптера с Iris тестовете, маркирани за обединено поръчване.",
    },
    snackbar_added: "Панел \u2018{code}\u2019 е добавен",
    snackbar_updated: "Панел \u2018{code}\u2019 е актуализиран",
    snackbar_deleted: "Панел \u2018{code}\u2019 е изтрит",
    mappings: {
      section_title: "LIS Съответствия",
      empty_title: "Няма LIS съответствия",
      empty: "Няма конфигурирани LIS съответствия за този панел.",
      columns: {
        mapping_key: "LIS ID",
        lis_name: "LIS име",
        date_time: "Дата / Час",
        actions: "Действия",
      },
      fields: {
        mapping_key: "LIS ID",
        mapping_key_hint: "Уникално ID, използвано от LIS за идентифициране на панела",
        mapping_key_placeholder: "напр. FBC-01",
        lis_name: "LIS име",
        lis_name_hint: "Наименование, показвано в отчета на LIS",
        lis_name_placeholder: "напр. Пълна кръвна картина",
      },
      validation: {
        mapping_key_required: "Кодът е задължителен",
        mapping_key_too_long: "Кодът трябва да е до 50 символа",
        mapping_key_duplicate: "Вече има съответствие с този код за този панел",
        lis_name_required: "LIS името е задължително",
        lis_name_too_long: "LIS името трябва да е до 255 символа",
      },
      action_add: "Добавяне на съответствие",
      action_edit: "Редактиране на съответствие",
      add_subtitle: "Свържете този панел с външен LIS идентификатор.",
      subtitle_panel: "Код на панел",
      subtitle_id: "ID на панел",
      subtitle_lis_id: "LIS ID",
      subtitle_created: "Създаден",
      subtitle_panel_tooltip: "Панелът, към който принадлежи съответствието",
      subtitle_panel_id_tooltip: "Системен идентификатор на панела",
      subtitle_lis_id_tooltip: "LIS ключ за съответствие",
      subtitle_created_tooltip: "Дата на създаване на съответствието",
      delete_title: "Премахване на LIS съответствие",
      delete_message: "Това съответствие ще бъде премахнато от конфигурацията на панела.",
      snackbar_added: "Съответствието \u2018{key}\u2019 е добавено",
      snackbar_updated: "Съответствието \u2018{key}\u2019 е актуализирано",
      snackbar_deleted: "Съответствието \u2018{key}\u2019 е премахнато",
      add_error: "Грешка при добавяне на съответствие. Моля, опитайте отново.",
      update_error: "Грешка при обновяване на съответствие. Моля, опитайте отново.",
      delete_error: "Грешка при премахване на съответствие. Моля, опитайте отново.",
    },
    tests: {
      section_title: "Тестове",
      empty_title: "Няма тестове в панела",
      empty: "Няма добавени тестове към този панел.",
      single_unit_hint:
        "Панелите като единичен елемент се поръчват като един панел; тестовете са информационни и не разширяват поръчката.",
      columns: {
        test: "Тест",
        test_name: "Тест",
        test_code: "Код",
        fixed: "Фиксиран",
        joined: "Обединен",
        include_fixed: "Фиксиран",
        include_joined: "Обединен",
        date_time: "Дата / Час",
        actions: "Действия",
      },
      test_enabled: "Активен",
      test_disabled: "Деактивиран",
      fields: {
        test: "Тест",
        test_hint: "Изберете тест от този апарат за включване в панела.",
        test_code_label: "Код на тест",
        test_modifier_label: "Модификатор",
        test_id_label: "ID на тест",
        test_locked_hint: "Избраният тест не може да бъде променян след добавянето му към панела.",
        include_when_fixed: "Включване в панели с фиксиран списък",
        include_when_fixed_hint: 'Тестът ще бъде включен в панели с режим "Фиксиран списък от тестове".',
        include_when_joined: "Включване в панели с обединен списък",
        include_when_joined_hint: 'Тестът ще бъде включен в панели с режим "Обединен списък от тестове".',
        include_fixed: "Включване в панели с фиксиран списък",
        include_fixed_hint: 'Тестът ще бъде включен в панели с режим "Фиксиран списък от тестове".',
        include_joined: "Включване в панели с обединен списък",
        include_joined_hint: 'Тестът ще бъде включен в панели с режим "Обединен списък от тестове".',
      },
      validation: {
        test_required: "Изберете тест",
        include_mode_required: "Активирайте поне един режим на включване за този тест.",
        include_one: "Активирайте поне един режим на включване за този тест.",
      },
      action_add: "Добавяне на тест",
      action_edit: "Редактиране на тест в панел",
      add_subtitle: "Изберете тест от апарата и кога да бъде включван от панела.",
      subtitle_panel_tooltip: "Панелът, към който принадлежи тестът",
      subtitle_test_code_tooltip: "Код на теста за LIS нареждания",
      subtitle_id_tooltip: "Системен идентификатор на теста",
      subtitle_test_name_tooltip: "Показвано наименование на теста",
      subtitle_created_tooltip: "Дата на добавяне на теста към панела",
      subtitle_created: "Създаден",
      included: "Включен",
      not_included: "Не е включен",
      included_fixed: "Включен в панели с фиксиран списък",
      not_included_fixed: "Не е включен в панели с фиксиран списък",
      included_joined: "Включен в панели с обединен списък",
      not_included_joined: "Не е включен в панели с обединен списък",
      delete_title: "Премахване на тест от панел",
      delete_message: "Този тест вече няма да бъде включван от панела.",
      snackbar_added: "Тестът '{test}' е добавен към панела",
      snackbar_updated: "Тестът '{test}' е актуализиран",
      snackbar_deleted: "Тестът '{test}' е премахнат от панела",
      add_error: "Грешка при добавяне на тест към панела. Моля, опитайте отново.",
      update_error: "Грешка при обновяване на тест в панела. Моля, опитайте отново.",
      delete_error: "Грешка при премахване на тест от панела. Моля, опитайте отново.",
    },
  },

  dialogs: {
    sample_types: {
      title: "Видове проби",
      subtitle: "Видове проби, конфигурирани за този апарат",
      empty_title: "Не е конфигурирано",
      empty_description: "Няма конфигурирани видове проби за този апарат.",
      status_active: "Активен",
      status_inactive: "Неактивен",
      status_tooltip: "Указва дали този вид проба е активен и достъпен за ползване от този апарат.",
      columns: {
        code: "Код от апарата",
        mapping_key: "LIS ID",
        name: "Наименование",
        status: "Статус",
        actions: "Действия",
      },
      add_title: "Добавяне на вид проба",
      add_subtitle: "Въведете данните за новия вид проба.",
      subtitle_instrument: "Апарат",
      subtitle_instrument_lis_id: "LIS ID на апарат",
      subtitle_lis_key: "LIS ID на вид проба",
      subtitle_instrument_tooltip: "Апаратът, за който е конфигуриран видът проба",
      subtitle_instrument_lis_id_tooltip: "LIS ID на апарата",
      subtitle_sample_code_tooltip: "Вътрешен код на апарата за вида проба",
      subtitle_lis_key_tooltip: "LIS код за вида проба",
      edit_title: "Редактиране на вид проба",
      fields: {
        code: "Код от апарата",
        code_hint: "Кодът, изпращан от апарата в съобщенията (напр. SER, EDTA, 1).",
        code_placeholder: "напр. SER",
        mapping_key: "LIS ID",
        mapping_key_hint: "Начинът, по който LIS идентифицира материала.",
        mapping_key_placeholder: "напр. 5 или SERUM",
        name: "Наименование",
        name_hint: "Пълно описателно наименование, показвано в резултатите и LIS.",
        name_placeholder: "напр. Серум",
        active: "Активен",
        active_hint: "Видът проба е приет и може да се обработва от апарата",
        inactive: "Неактивен",
        inactive_hint: "Видът проба е деактивиран и няма да бъде приет от апарата",
      },
      validation: {
        code_required: "Кодът е задължителен",
        code_too_long: "Кодът трябва да е най-много 50 символа",
        mapping_key_required: "Ключът за съответствие е задължителен",
        mapping_key_too_long: "Ключът трябва да е най-много 50 символа",
        key_taken: "Вече съществува вид проба с този код и ключ",
        name_required: "Наименованието е задължително",
        name_too_long: "Наименованието трябва да е най-много 100 символа",
      },
      action_add: "Добавяне на вид проба",
      action_edit: "Редактиране на вид проба",
      action_delete: "Премахване на вид проба",
      delete_title: "Премахване на вид проба",
      delete_message: "Този вид проба ще бъде премахнат от конфигурацията на апарата.",
      snackbar_added: "Видът проба '{code}' е добавен",
      snackbar_updated: "Видът проба '{code}' е актуализиран",
      snackbar_deleted: "Видът проба '{code}' е премахнат",
    },
    rights: {
      title: "Права",
      subtitle: "Права за достъп на потребители за този апарат",
      empty_title: "Не е конфигурирано",
      empty_description: "Няма конфигурирани права за достъп за този апарат.",
      access_view: "Преглед",
      access_view_validate: "Преглед + Валидация",
      access_view_validate_edit: "Преглед + Валидация + Редакция",
      role_iris_admin: "Ирис Админ",
      role_iris_user: "Ирис Потребител",
      access_tooltip: "Определя какви действия могат да извършват потребителите в тази роля на апарата.",
      created_time_tooltip: "Дата и час на създаване на записа за достъп.",
      selector_user: "Потребител",
      selector_group: "Група",
      selector_toggle_hint: "Кликнете за преминаване между Потребител и Група",
      columns: {
        user: "Потребител",
        role: "Роля",
        created_time: "Дата / Час",
        access: "Ниво",
        actions: "Действия",
      },
      add_title: "Добавяне на права",
      add_subtitle: "Присвоете ниво на достъп на потребител или група.",
      subtitle_instrument: "Апарат",
      subtitle_instrument_lis_id: "LIS ID на апарат",
      subtitle_id: "ID",
      subtitle_created: "Създаден",
      subtitle_instrument_tooltip: "Апаратът, за който се прилага правилото за достъп",
      subtitle_instrument_lis_id_tooltip: "LIS ID на апарата",
      subtitle_id_tooltip: "Системен идентификатор на записа за достъп",
      subtitle_created_tooltip: "Дата на създаване на записа за достъп",
      edit_title: "Редактиране на права",
      fields: {
        user: "Потребител",
        user_hint: "Потребителско име",
        user_placeholder: "напр. Иван Петров",
        group: "Група",
        group_hint: "Име на групата",
        group_placeholder: "напр. Лаборанти",
        role: "Роля",
        access: "Ниво на достъп",
        access_hint: "Определя какви действия могат да извършват потребителите с тази роля на апарата.",
      },
      validation: {
        user_required: "Потребителското име е задължително",
        user_too_long: "Потребителското име трябва да е най-много 100 символа",
        user_taken: "Потребителът вече има запис за достъп",
        group_required: "Името на групата е задължително",
        group_too_long: "Името на групата трябва да е най-много 100 символа",
        group_taken: "Групата вече има запис за достъп",
      },
      action_add: "Добавяне на права",
      action_edit: "Редактиране на права",
      action_delete: "Премахване на права",
      delete_title: "Премахване на права",
      delete_message_user: "Потребителят ще загуби достъп до апарата.",
      delete_message_group: "Групата ще загуби достъп до апарата.",
      snackbar_added: "Правото за '{user}' е добавено",
      snackbar_updated: "Правото за '{user}' е обновено",
      snackbar_deleted: "Правото за '{user}' е премахнато",
    },
    flags: {
      title: "Флагове",
      subtitle: "Флагове на резултати, конфигурирани за този апарат",
      empty_title: "Не е конфигурирано",
      empty_description: "Няма конфигурирани флагове за този апарат.",
      status_filter: "Блокира публикуването",
      status_no_filter: "Не блокира публикуването",
      columns: {
        code: "Код",
        description: "Описание",
        severity: "Критичност",
        severity_tooltip:
          "Показва нивото на критичност на флага — от информационни бележки до критични условия, изискващи незабавно действие",
        created_time: "Дата / Час",
        created_time_tooltip: "Дата и час на създаване на флага.",
        actions: "Действия",
      },
      add_title: "Добавяне на флаг",
      add_subtitle: "Дефинирайте нов флаг за резултати на апарата.",
      subtitle_instrument: "Апарат",
      subtitle_instrument_lis_id: "LIS ID на апарат",
      subtitle_flag: "Код на флаг",
      subtitle_flag_description: "Описание",
      subtitle_created: "Създаден",
      subtitle_instrument_tooltip: "Апаратът, към който принадлежи флагът",
      subtitle_instrument_lis_id_tooltip: "LIS ID на апарата",
      subtitle_flag_code_tooltip: "Код на флага, изпратен от апарата",
      subtitle_created_tooltip: "Дата на конфигуриране на флага",
      edit_title: "Редактиране на флаг",
      fields: {
        code: "Код",
        code_hint: "Интервалите се заменят с долна черта.",
        code_placeholder: "напр. MAINTENANCE_MODE",
        description: "Описание",
        description_hint: "Кратко описание, показвано в интерфейса.",
        description_placeholder: "напр. Режим на поддръжка",
        flag_type: "Филтриране",
        is_filter: "Блокира публикуването",
        is_filter_hint: "Резултатите с този флаг ще бъдат задържани и няма да достигнат до LIS.",
        not_filter: "Не блокира публикуването",
        not_filter_hint: "Резултатите с този флаг се изпращат към LIS без ограничения.",
        severity: "Ниво на критичност",
        severity_information: "Информативно",
        severity_information_hint: "Информационна бележка \u2014 не е необходимо действие",
        severity_warning: "Внимание",
        severity_warning_hint: "Потенциален проблем \u2014 препоръчва се проверка",
        severity_danger: "Сериозно",
        severity_danger_hint: "Сериозен проблем — необходимо е действие",
        severity_panic: "Критично",
        severity_panic_hint: "Критично състояние \u2014 необходимо е незабавно действие",
      },
      validation: {
        code_required: "Кодът е задължителен",
        code_too_long: "Кодът трябва да е най-много 100 символа",
        code_taken: "Вече съществува флаг с този код",
        description_required: "Описанието е задължително",
        description_too_long: "Описанието трябва да е най-много 500 символа",
      },
      action_add: "Добавяне на флаг",
      action_edit: "Редактиране на флаг",
      action_delete: "Изтриване на флаг",
      delete_title: "Изтриване на флаг",
      delete_message: "Този флаг ще бъде премахнат от конфигурацията на апарата.",
      snackbar_added: "Флагът '{code}' е добавен",
      snackbar_updated: "Флагът '{code}' е актуализиран",
      snackbar_deleted: "Флагът '{code}' е премахнат",
    },
  },
};
